/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';

import {IPageResponse, SortDirection} from "../../common/interfaces/IPageResponse";
import {DocumentType, DOCUMENT_TYPES_AGGREGATE, DOCUMENT_TYPES_MULTI, IFuelInvoice, IFuelInvoiceRequest, IFuelInvoiceSortFields} from "../../models/fuel-invoice";
import moment from "moment";
import {dateFormat} from "../../common/dateFormatterConfig";
import {CustomerPermission, InitContextProps, useAuthContext} from "../../services/context/authentication.context";
import DocumentService from 'services/document.service';
import { FuelInvoicePaymentModal } from 'components/Modals/FuelInvoicePaymentModal/FuelInvoicePaymentModal';
import { AxiosResponse } from 'axios';
import PaymentService from 'services/payment.service';
import { BankType, DocumentPayment, PaymentLocale, PaymentMethodType } from 'models/payment';

export function NewInvoices(props: any) {
    const [invoices, setInvoices]: [Array<IFuelInvoice>, any] = useState([]);
    // TO-DO: modal content and functionality
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [request]: [IFuelInvoiceRequest, any] = useState({
        size: 3,
        page: 0,
        sortDirection: SortDirection.ASC,
        sortField: IFuelInvoiceSortFields.PAYMENT_DEADLINE_DATE,
        onlyNotPaid: true,
        types: DOCUMENT_TYPES_MULTI + ',' + DOCUMENT_TYPES_AGGREGATE,
    });

    const {state, hasPermission}: InitContextProps = useAuthContext();
    const { customerId, customer } = state;


    const getDeadlineText = (deadlineDate: string) => {
        const diff = moment({hours: 0}).diff(deadlineDate, 'days');
        const date = moment(deadlineDate).format(dateFormat);
        if (diff >= 0) {
            return <span className='card__warning-text'>{date}</span>;
        }
        return <span>{date}</span>;
    };

    useEffect(() => {
        if (customerId !== null) {
            DocumentService.getInvoices(customerId, request).then((res: IPageResponse<IFuelInvoice>) => {
                setInvoices(res.content.filter(i => i.totalAmount - i.paymentAmount > 0));
            });
        }     
    }, [customerId]);

    const getDocumentFile = async (document: IFuelInvoice) => {
        if (customerId === null)
            return;
        
        await DocumentService.getDocumentFileWithDownload(document.remoteDocumentId);
    }

    const beginPayment = (paymentMethodType: PaymentMethodType, documentPayments: DocumentPayment[], bankType?: BankType) => {
        if (customerId === null || customer?.contactId === null) return Promise.resolve();

        return PaymentService.beginPayment({
            bankType,
            locale: PaymentLocale.ET,
            customerId,
            contactPersonId: customer.contactId,
            documentPayments,
            paymentMethodType
        }).then((response: AxiosResponse) => {
            window.location.href = response.data;
        });
    }

    const getDocumentTypeLabel = (type: DocumentType) => type === DocumentType.VA_1 ? 'Koondarve' : 'Hulgiarve';

    const hasFactoringInvoices = invoices?.some(invoice => !!invoice.remoteFactoring);

    return (
        <>
        { invoices && invoices.length ? 
        <div className='new-invoices__container'>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="u-fs-20 mb-0">UUED ARVED</h2>
                {
                    (!hasFactoringInvoices && hasPermission(CustomerPermission.WEB_ADMIN)) ? (
                        <button 
                            className="btn btn-primary d-flex align-items-center" 
                            onClick={() => setPaymentModalVisible(true)}
                        >
                            Maksma<i className='icon__arrow-right icon--16 ml-2'></i>
                        </button>
                    ) : (
                        <button 
                            className="btn btn-primary d-flex align-items-center" 
                            onClick={() => props.history.push('/arved')}
                        >
                            Vaata arveid<i className='icon__arrow-right icon--16 ml-2'></i>
                        </button>
                    )
                }
            </div>
            <div className='new-invoices__card-container'>
                {invoices.map((invoice: IFuelInvoice) =>
                    <div key={invoice.remoteDocumentId} className='new-invoices__card'>
                        <i className='icon__canister'></i>
                        <div className='d-flex flex-column'>
                            <h3 className="cursor-pointer" onClick={() => getDocumentFile(invoice)}>
                                <span className="d-md-inline d-none">{invoice.documentNumber}</span>
                                <span className="d-md-none d-inline">{invoice.documentNumber.split("-", 2)[0]}</span>
                            </h3>
                            <span className='card__text'>{getDocumentTypeLabel(invoice.documentType)}&nbsp;&nbsp;|&nbsp;&nbsp;{getDeadlineText(invoice.paymentDeadlineDate)}</span>
                            <div className='d-flex flex-column'>
                                <span className='card__price'>{(invoice.totalAmount - invoice.paymentAmount).toFixed(2) + "€"}</span>
                                <small className='mt-n1'>Sisaldab käibemaksu</small>
                            </div>                            
                        </div>

                    </div>
                )}
            </div>
            {
                invoices ?
                <FuelInvoicePaymentModal
                    visible={paymentModalVisible}
                    handleModalHide={() => setPaymentModalVisible(false)}
                    onSubmit={(paymentMethodType, payableInvoices, bankType) => beginPayment(paymentMethodType, payableInvoices, bankType)}
                    payableInvoices={invoices}
                    paymentStatus=''
                /> : null
            }
        </div>
        : null }
        <div id="payment-response-form-container" className="d-none"></div>
        </>
    )
}